import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-t-stock-transfer-in-approve',
  templateUrl: './t-stock-transfer-in-approve.component.html'
})
export class TStockTransferInApproveComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/view/transactions/t-stock-transfer-in-approve/t-stock-transfer-in-approve.component.ts